import React from 'react';
import { motion } from 'framer-motion';
import { DownloadIcon, FileTextIcon } from 'lucide-react';
import { ActionButton } from './ActionButton';
const mockupUrl = 'https://cdn.magicpatterns.com/uploads/bPKpWo5K2qooEi2GdDYUyC/Mockup_1x1_-_OFN1_-_(S.E.A).webp';
export function Hero() {
  // Headline and mockup render immediately (no entrance animation) so the
  // largest contentful paint is never delayed by JavaScript.
  return <section className="relative overflow-hidden bg-surface px-4 pb-16 pt-12 sm:pb-24 sm:pt-16" data-id="element-64" data-mp="1285x3nzc5smb">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-primary/40" data-id="element-65" data-mp="xbp9cuw1tg9r" />
      <div className="relative mx-auto max-w-5xl text-center" data-id="element-66" data-mp="sa9nj0m1r5qb">
        <p className="-mb-2.5 -mt-11 font-display text-lg font-bold tracking-brand text-primary-soft sm:text-2xl" data-id="element-67" data-mp="ncgkuhjyctus">
          🌿BIOMA LÍVIDO™
        </p>
        <h1 className="mx-auto mt-5 max-w-5xl font-display text-lg font-bold text-foreground sm:text-5xl lg:text-6xl" style={{
        fontSize: "22px"
      }} data-id="element-68" data-mp="3d33f4zea6vla">
          Comprendé los patrones emocionales que te lastiman{' '}
          <span className="text-primary-soft" data-id="element-69" data-mp="3j6odtpknkwsq">
            y empezá a cambiarlos sin sentirte perdida.
          </span>
        </h1>
        <div className="mx-auto -my-3 max-w-xs sm:-my-7 sm:max-w-lg" data-id="element-70" data-mp="39b4hx3639y3z">
          <img src={mockupUrl} alt="Mockup del Kit Autocuidado Emocional" width="1254" height="1254" fetchPriority="high" loading="eager" decoding="async" className="aspect-square w-full drop-shadow-2xl" data-id="element-71" data-mp="3e9fsjg47kcn9" />
        </div>
        <div className="mx-auto max-w-2xl" data-id="element-72" data-mp="3599iy5bmrwtd">
          <p className="-mb-2 font-display text-base font-bold tracking-label text-highlight sm:text-xl" data-id="element-73" data-mp="35aax4iny0zfb">
            KIT AUTOCUIDADO EMOCIONAL
          </p>
          <p className="-mb-2.5 mt-3 text-sm leading-relaxed text-foreground-soft sm:text-base" data-id="element-74" data-mp="2vievixmner6c">
            Un kit digital con protocolos paso a paso, guiones para poner límites y rutinas de autocuidado listas para usar.
          </p>
          <div className="-mb-3 mt-5 flex flex-wrap justify-center gap-2 text-xs font-medium text-foreground-muted sm:text-sm" style={{
          marginBottom: "-18px"
        }} data-id="element-75" data-mp="2lk8vymobdx4n">
            <span className="inline-flex items-center gap-2 rounded-full border border-foreground/15 bg-canvas px-3 py-2" data-id="element-76" data-mp="na9yql90f8jc">
              <FileTextIcon className="h-4 w-4 text-primary-soft" data-id="element-77" data-mp="ichy92uaue3j" />
              100% PDF
            </span>
            <span className="inline-flex items-center gap-2 rounded-full border border-foreground/15 bg-canvas px-3 py-2" data-id="element-78" data-mp="db2cf8kas3k3">
              <DownloadIcon className="h-4 w-4 text-highlight" data-id="element-79" data-mp="161t0korasgjs" />
              Materiales descargables
            </span>
          </div>
        </div>
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-7 max-w-lg" data-id="element-80" data-mp="111eql164ywj4">
          <ActionButton href="#pricing" showTrust data-id="element-81" data-mp="3hrdbx2pxho3l">
            🌿 QUIERO MI KIT DE AUTOCUIDADO EMOCIONAL
          </ActionButton>
        </motion.div>
      </div>
    </section>;
}